/**
 * The HNS badge on container nodes (S8 Task 8.9, spec §5.1): a container of an account whose hierarchical namespace
 * is confirmed carries `hns: true` (rendered as `[HNS]` by `StorageNodeLabel`). Applied to freshly listed children and
 * to the children a rebuilt service folder keeps when account info arrives later; `no` / `unknown` add nothing.
 */
import type { DatabaseExplorerNode } from '../../../explorer/models/nodeTypes';

export function withHnsBadges<T extends DatabaseExplorerNode>(children: T[], hns: 'yes' | 'no' | 'unknown' | undefined): T[] {
  if (hns !== 'yes') return children;
  return children.map((child) => {
    if (child.type !== 'storage-container') return child;
    const metadata = (child as { metadata: { hns?: boolean } }).metadata;
    return metadata.hns ? child : ({ ...child, metadata: { ...metadata, hns: true } } as T);
  });
}
